import { render, staticRenderFns } from "./SmsContactDialog.vue?vue&type=template&id=b818a1f6&"
import script from "./SmsContactDialog.vue?vue&type=script&lang=js&"
export * from "./SmsContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./SmsContactDialog.vue?vue&type=style&index=0&id=b818a1f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsContactDialog.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports